import { Text } from '@mantine/core';

export const BaseText = Text;